<script setup>
import { computed, onMounted, ref, nextTick } from 'vue'

const emit = defineEmits(['click'])
const props = defineProps({
  id: { 
    type: String, 
    default: Date.now() },
  title: { type: String, default: 'Title' },
  bodyText: { type: String, default: 'BodyText' },
  showCancelButton: { type: Boolean, default: true },
  closeOnBackdrop: { type: Boolean, default: false },
  passThrough: { type: Object, default: () => undefined },
  label: { type: String, default: 'Label' },
})

const show = ref(true)
const modalContent = ref(null)

const sanitizeBodyText = computed(() => {
  return props.bodyText
    .replace(/</g, '&lt')
    .replace(/>/g, '&gt')
    .replace(/"/g, '&quot')
    .replace(/'/g, '&#39')
})

const okEvent = () => {
  emit('click', props.passThrough ? props.passThrough : true)
}
const cancelEvent = () => {
  emit('click', false)
}

onMounted(() => {
  nextTick(() => {
    modalContent.value.focus()
  })
})
</script>

<template>
  <div v-if="show" class="modal-backdrop position-fixed">
    <div :id="id" class="modal" tabindex="-1" role="dialog" :aria-labelledby="label" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div ref="modalContent" class="modal-content" tabindex="0" @focusout="closeOnBackdrop && cancelEvent()">
          <div class="modal-header">
            <h5 id="modalLabel" class="modal-title">{{ title }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="cancelEvent()">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <slot>
              <p>{{ sanitizeBodyText }}</p>
            </slot>
          </div>
          <div class="modal-footer">
            <button v-if="showCancelButton" type="button" class="btn btn-secondary" data-dismiss="modal" @click="cancelEvent()">Cancel</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="okEvent()">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-backdrop {
  z-index: 1000;
  background-color: rgba(0, 0, 0, 0.3);
}
.modal {
  display: block;
  top: 30%;
}
</style>
